import { reactive } from "vue";

export const orderDefaults = {
    EmployeeCode: "",
    Amount: 0.0,
};

export const OrderStore = reactive(orderDefaults);
